import {enumToValues} from '@netx/core-next/utils/enum';
import {AttributeType} from '@netx/core-attribute/constants';
import {attributesStore} from '@netx/core-attribute/store';
import {MetadataType} from '../constants';

export const getMetadataTypeOptions = (attributeName: string) => {
	const attr = attributesStore.getAttributeByName(attributeName);
	const options = enumToValues(MetadataType);
	if (!attr) return options;

	const canRangeSearch = [AttributeType.DATE, AttributeType.NUMBER].includes(
		attr.type,
	);

	return canRangeSearch
		? options
		: options.filter((opt) => opt !== MetadataType.MATCH_ANY_RANGE);
};

export default getMetadataTypeOptions;
